export const sponsoredByLogoLine1 = [
  {
    id: 1,
    name: "Top Golf Jakarta",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/658da97227bf2dd36c42818ef404447abca687127d72d3f60a64095537ae1b39d6b2846721ccedffec60deab22ce249767ebc69449155b80aca35bcd5d0c698af887ac3b3da72e9cb2fc0c7fd8db1a5b4d5c82100c4990bd7a538b2c20d8ede8236fea5fdb7f0161cdf62081cf703be687875a3d8a130a767c05/rez-file-1753073681114.png",
  },
  {
    id: 2,
    name: "Mercury",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/850e032e50c5d845bc7329c96601dbf4ef5af3f918a88bda96abb9cbc9d9c5799260d475a59d6ce80df75e910f103a56f51b0622e530515d46e2800a4bc0a11515023365a7949787850476ce9035e68387b58a60121984262ea161f06c1a38cb2ba622dba6f7bf6ada21232c37e8ec9cdb4ae4b73b3205d6ec5f/rez-file-1753073876796.png",
  },
];

export const sponsoredByLogoLine2 = [
  {
    id: 1,
    name: "Merchmaniacs",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/9db8ee595f78bf988c587e1b6074e4613578214fc9fa943accae6fbcfa183d079e95b1c3c280bd14a1ad47b30df730ed301a5ec49df4c7d7633d62db8281fba0e6d8f875ed5a2a0686a3fc7ba56a7d082183e48ac220760206c79ec5bda4fe77f05a70fb8d9dc74797b873e80a53b75d89904cd5b95e6caf5341/rez-file-1753074538607.png",
  },
  {
    id: 2,
    name: "Bank Mandiri",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/2d2ef5bf3deabe874fd95ab82c88cfe63e87f751a12c24904cd359672e1914df6fb0946816eba72aa6ee6375c2d6bb8a7bb4a563d56dc5a402f732c0818b4d56c2c91c15a159eb2333a86ecf0d6a0910a1e72f7677028527e6a092cce3f0b9916ed5c5f6e5b3a3e8be16820067f4a813644a2d415508ee0919c0/rez-file-1753076476128.png",
  },
  {
    id: 3,
    name: "IM3 Platinum",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/fe7a0100109eb1ebaacadfe54ebd17a14657ea79cbfd08aaaf4306b59ae512d2252fd2d824f5cbc387c3f3abb9d8f122bafb701614c161e9fff312f6a0c25c1a32625954a25f39d1e4e4d9bf69733a33883871bbdc66fe0ebf5efe1fc27f0f5222e5795abe87f0365cd5234b6841a445a1b2c6bab86dc658fffd/rez-file-1753076489892.png",
  },
  {
    id: 4,
    name: "Joumpa",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/8c9d178a1cfeea898b4c3698a76cfa0ad4826c3132b62e8897f08efb552113b4711079ed28e7f941f887d21d9337f8825ad6d6cbc428d82a0bef20e8e217044dd156be46687b403841e982cf6093a71f221dd3aa575253336e4ae8ffbcd7a06c4f3324efd78146fb28f7aa21f82d3be476d4bc9225d0be61baec/rez-file-1753076505489.png",
  },
  {
    id: 5,
    name: "MST",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/d34a1a0ed6ddbff098c0a29da995b69b13fcde3431b3cb5de4c0a0d424b966a76fcbbf7afbc46d49c6695d0ca343cb5f6aa0e3f1c28be8b786ac422d2e1435e597b0015d9b67fcee8c10baa87e62d8159c56996281ff5369054c2e15b82cce8bc2b95391d0df444c8d6027d37831f82f1a2603e0867602366291/rez-file-1753076524481.png",
  },
];

export const sponsoredByLogoLine3 = [
  {
    id: 1,
    name: "Deorex",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/79f1b3fab99441d257b4985549dd719659103e75387b9dee1c69adf9e594de171909254a9f840b9ce34cbd8c581886cac9365d22e5b2fbfde241e9355f8398d3667b3362b4479a164d117b7e1738091222867e105b3b9c0f5e0060e28651443c7525d99a03c7c3fb34cd0fd22ec6effb7f39cd14332ebc79ac58/rez-file-1753076540923.webp",
  },
  {
    id: 2,
    name: "Bakhtera",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/06352a2c63e99d4de4ebf897213ed2de61d223a32214aeb05dd38c35d9bf8acdad003bdeb5b9549507580ea50b29991fcb839c3f086b96988eaaddae549bbf7df53eb9d094c766914acc0fe6ba4d48e922b477950aba4440aa92cee8e853d1c52257061c0b028593b78f53fa406e3d61efe29a2bf9288a578b78/rez-file-1753076558981.png",
  },
  {
    id: 3,
    name: "Smartscore",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/4f6511db0bad6be9b8f39bcd1a5e6899305ed9453e9729d38f94f4f1d8796b6587aca3e10a0ee227a9303651e1cb6de2eb0e897eb27fde442a6bc15dec96434c7cf06fea0422309d5544826ce232c777db6ce88ccd6dcb8808f8d57612a4147cc5c4e15c6cc6125a616cc6b5cea81c0ba06b8adce550b0249ebd/file-1753077236532.jpeg",
  },
  {
    id: 4,
    name: "Trust Golf Indonesia",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/fa25520c6db12d2a34721637f1de55b9446527bf80d9c253e4cc73b185cbcae4fcf04e42a7931d23f4d9b6b356c28117f02bd0651508bbe4cebfaf3467ca6603d7f2e79308a2c4dfb817d28670f394f2151347868bb5f246e2f44a1258f66815d4aa10a3e7e3d98364f2bd718a1ac39e9a13093ff8c0af641af0/file-1753077005199.png",
  },
  {
    id: 5,
    name: "Wonhae",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/207899332be4399242aa8e9f36c32661760dcc018d196f68d048e39aecc23724de634c926baee101edc17c61d295991f9885e5d0cac87c2eadf64f6875dc0b0a4128894aa8134c8d088f55732e5132fda20d815dcce0fca1e6a1ec2afc4f5413a26b1a751569623e63450909686ae766122fa046d9aaad6ac5db/rez-file-1753076573147.png",
  },
];

export const supportedByLogo = [];

export const presentedByLogo = [
  {
    id: 1,
    name: "Marriott International",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/012f79f18bd4ee5ca24a024d02924ba84f004046e8a139fd33e82d02164b994a514bb11d7c5ece7ed43c62dbd3638a2aabbcefb82935d1a511710f3308cc8ca97f0c9058a339dbd73aa6f98b3fbb2fc972914157ba54e7720645664dd6d7822caabdfb2b35dcfde734715b8dca4bd96059465fdaa95661d4c035/rez-file-1750150206233.png",
  },
  {
    id: 2,
    name: "Marriott Council",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/fabd98a6adfa5fd8ee5b24c3613b4540f633c3c9af2c89195ab52743fe45dd9200d19f2d756a5846601013eecdf3d86d772389481e813a9abecd4b603e54012f9194f66c549c3f7e990c3b2d938e474aecb0cd5974809db1e1a809ca6c35d2dd462db8c831b1719c0e77dbce5e20d4a93817fc6e3d918cef7d3c/rez-file-1750150254456.jpeg",
  },
  {
    id: 3,
    name: "BIG Event Asia",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/bab0156cfcbd877f006cec71e21e68086442529a73cef3e7dbeb7d8d13895d28412dc447faf601ba595936346738fe0efc66d42120e85245c311247c09c39d58976906ba647d24935fe6ad5d18e22e884bf57bd1faac7361aaeff3c69fd44f53f9a38fa03a2a2f50038b1047d5ba8a151ae6ae054ff746ba7226/rez-file-1736416276911.png",
  },
];

export const communityPartnerLogo = [];

export const ticketingByLogo = [
  {
    id: 1,
    name: "Cloudxier",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/b4d1290c6711cf20d5dda63611a56f04b15bdc1129f5ea3a848bdbdf3055ab024e14b3664244785c33015dd74314e79b9d18d8ee9d2dede39cb088937d8deb58999411a12605891e67a9109bd15d9fe536ece3a3f4a1b89903ef0639066f74d9c56152fffb8f5ca1e1a3705dd37dc0de70b33c52291bd78adaaf/file-1718956888002.png",
  },
];

export const djPerformByLogo = [];

export const venueByLogo = [
  {
    id: 1,
    name: "Sedayu Indo Golf",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/93538e278cb51cdd61336a9499aa2e6fca502c9a7d3f62f62f97d75f620050f318bd4898f4a689c58b08a89ddbbedccac1bdfc42316e6eb9c8eef9159bf0d501971e9fe1dee6b49b132e6dabcc0143b0a4fcf4ab3caeb2f1a17fb16aaa69e4added62344894f1d47995318b0681f0efa7858f1b253e7d5ec1721/rez-file-1750149078474.PNG",
  },
  {
    id: 2,
    name: "Brassey",
    image_url:
      " https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/5e977876103811303d1c97db836108b0d12f3fa3c41e955e0f9f1a14edad884a4705aab49bff28dc51aaa1fcab70bcb004a0bfa4159740698d595e53dad1f50effa409b48441cc69c9b980a1ca76702c540cca14fa6f54cf564b3328c95d91d3946655c30d56e088ecbad245a7fbefaa7aecf2f859828bbc4b88/file-1753072646174.png",
  },
];

export const mediaByLogo = [
  {
    id: 1,
    name: "BO Magz",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/96a58847df383550eac92b1273375bb2d1bdd40cdddc34354bc91b4ee48da7275b0caa7342449a8d7891e390c8cb7e7cb20e156d50b4af375370f796fd8c3f1b149ec8ba8f97a9c1ea2c3344b63fd4aa70971b238088529cebc63219c68d9fc930685eeb1e2cc7a9d760e234926d37d81b7a7940266cf5b9a4fd/rez-file-1753073240462.png",
  },
  {
    id: 2,
    name: "Golftrovert",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/43c0b06d55b0afe7810094ce11e8c55d86baa434d75593fa907e3b24d83fab6ff3e9c99b7fea78c1c352a908a7173ca6b717f6912c5740ed94b9c5ac998374b1dce1deaab75033e49db533e6aa316ef6791b48b20440f7957166d7956f60e525f6d1157b84510400103f5353f399f1200cb028acb77b4ed54d00/rez-file-1753073281635.PNG",
  },
];
